import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

const Reply = ({ text, createdBy }) => {
    return (
        <div className="mb-3">
            <Row>
                <Col lg={2} />
                <Col lg={7}>
                    <div className="reply__container w-100 p-3">{text}</div>
                    <div className="ml-1 mt-2">
                        <span className="reply__user-info mr-1">{createdBy.firstName}.</span>
                        <span className="reply__user-info mr-1">{createdBy.position}</span>
                        <span className="reply__earned">Earned £{createdBy.earned}</span>
                    </div>
                </Col>
                <Col lg={3} />
            </Row>
        </div>
    );
};

Reply.propTypes = {
    text: PropTypes.string.isRequired,
    createdBy: PropTypes.object.isRequired,
};

export default React.memo(Reply);
